import {
  ALERT_MESSAGE_TYPE,
  authAtom,
  hasToken,
  isMobileAtom,
  PAGE_NAME,
  ReservationCard,
  ReservationListNull,
  SkeletonReservationCard,
  useGetCompanyInfo,
  useGetReservations,
  useGetReservationsByUser,
  useRecoil,
} from '@orcar/common-d2c';
import { Fragment, useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { MY_PAGE_TABS } from '@/components/layout/MyPageWrapper';
import * as S from './styles';

export const MY_PAGE_CONTENT_WRAPPER_WIDTH = 792;

const MyPage = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const { recoilValue: user } = useRecoil(authAtom);

  const customerPhoneNumber = searchParams.get('customerPhoneNumber') || '';
  const customerName = searchParams.get('customerName') || '';

  const { recoilValue: isMobile } = useRecoil(isMobileAtom);

  const {
    data: reservationList,
    isError: reservationListError,
    isLoading: reservationListLoading,
  } = useGetReservations({
    params: {
      customerPhoneNumber,
      customerName,
    },
    enabled: !user && !hasToken(),
  });

  const {
    data: reservationListByUser,
    isError: reservationListByUserError,
    isLoading: reservationListByUserLoading,
  } = useGetReservationsByUser({
    enabled: !!user && !!hasToken(),
  });

  const { data: companyData } = useGetCompanyInfo();

  const handleClickReservationCard = (reservationId?: string) => {
    if (!reservationId) return;

    navigate(PAGE_NAME.reservation_detail + '/' + reservationId);
  };

  useEffect(() => {
    if (reservationListError || reservationListByUserError) {
      alert(ALERT_MESSAGE_TYPE.FAIL_ORDER_CONFIRMATION);
      navigate(PAGE_NAME.find_reservation);
    }
  }, [reservationListError, reservationListByUserError]);

  useEffect(() => {
    if (!user && !hasToken()) {
      if (reservationList?.length === 0) {
        alert(ALERT_MESSAGE_TYPE.FAIL_ORDER_CONFIRMATION);
        navigate(PAGE_NAME.find_reservation);
        return;
      }

      if (!customerName || !customerPhoneNumber) {
        alert(ALERT_MESSAGE_TYPE.INVALID_RESERVATION);
        navigate(PAGE_NAME.find_reservation);
      }
    }
  }, [user, hasToken, reservationList, customerName, customerPhoneNumber]);

  if (
    pathname.includes(MY_PAGE_TABS[0].pathname) ||
    pathname === PAGE_NAME.my_page
  )
    return (
      <Wrapper isMobile={isMobile}>
        <ContentWrapper>
          {!!user ? (
            reservationListByUserLoading ? (
              <>
                <SkeletonReservationCard isMobile={isMobile} />
                <SkeletonReservationCard isMobile={isMobile} />
              </>
            ) : reservationListByUser?.length === 0 ? (
              <ReservationListNull />
            ) : (
              reservationListByUser &&
              reservationListByUser.map(
                (reservation) =>
                  reservation && (
                    <ReservationCard
                      isMobile={isMobile}
                      key={reservation.id}
                      id={reservation.id}
                      vehicleModelName={reservation.vehicleModel.name}
                      companyName={companyData?.name || ''}
                      pickUpAt={reservation.pickUpAt}
                      dropOffAt={reservation.dropOffAt}
                      hasPayment={!!reservation.preReservation?.d2cPayment}
                      price={reservation.preReservation?.price}
                      reservationState={reservation.state}
                      onClick={() =>
                        handleClickReservationCard(reservation?.id)
                      }
                    />
                  ),
              )
            )
          ) : reservationListLoading ? (
            <>
              <SkeletonReservationCard isMobile={isMobile} />
              <SkeletonReservationCard isMobile={isMobile} />
            </>
          ) : reservationList && reservationList?.length > 0 ? (
            <Fragment>
              <S.SectionTitleWrapper>
                <S.SectionTitle isMobile={isMobile}>예약조회</S.SectionTitle>
              </S.SectionTitleWrapper>
              {reservationList.map((reservationData) => (
                <ReservationCard
                  isMobile={isMobile}
                  key={reservationData.id}
                  reservationState={reservationData.state}
                  pickUpAt={reservationData.pickUpAt}
                  dropOffAt={reservationData.dropOffAt}
                  hasPayment={!!reservationData.preReservation?.d2cPayment}
                  id={reservationData.id}
                  vehicleModelName={reservationData.vehicleModel.name}
                  companyName={companyData?.name || ''}
                  price={reservationData.preReservation?.price}
                  onClick={() => handleClickReservationCard(reservationData.id)}
                />
              ))}
            </Fragment>
          ) : null}
        </ContentWrapper>
      </Wrapper>
    );
};

export default MyPage;

const Wrapper = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ isMobile }) => (isMobile ? '23px 20px 15px' : '0')};
  width: ${({ isMobile }) => (isMobile ? '100%' : '792px')};
`;

const ContentWrapper = styled.div<{ width?: string }>`
  display: flex;
  flex-direction: column;
  width: ${({ width }) => width || '100%'};
  gap: 16px;
`;
